<template>
  <img class="logo" :src="LogoGAE" />
  <BadgeCheck class="mb-20 icon" color="var(--vc-success)" :size="36" />
  <h1 class="mb-20">Un email vous permettant de réinitialiser votre mot de passe a été envoyé</h1>
  <p class="mb-40">
    Vous allez recevoir dans quelques instants l’email contenant votre nouveau mot de passe. Si vous
    ne recevez pas l’email, merci de vérifier dans vos spams.
  </p>
  <CommonButton class="return" @click="$router.push('/')" filled>
    Retourner à l'écran de connexion.
  </CommonButton>
</template>

<script setup lang="ts">
import CommonButton from '@/components/common/CommonButton.vue'
import LogoGAE from '@/assets/images/logo-gae-color.png'
import { BadgeCheck } from 'lucide-vue-next'
</script>

<style scoped>
.icon {
  display: block;
}
.return {
  width: 100%;
}

.logo {
  margin-bottom: 80px;
}
</style>
